module.exports = __webpack_public_path__ + "img/w3_circle_up_white.22aed970.png";